import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './CarouselProvider.css';
import React, { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import 'react-multi-carousel/lib/styles.css';
import { canUseDOM, get, getGlobalDictionaryTerm } from '../../../utils';
import { ReactComponent as RightCarouselArrow } from "../../../resources/icons/RightCarouselArrow.svg";
import { ReactComponent as LeftCarouselArrow } from "../../../resources/icons/LeftCarouselArrow.svg";
var CarouselProvider = function CarouselProvider(_ref) {
  var moduleRef = _ref.moduleRef,
    children = _ref.children,
    getCurrentActiveItem = _ref.getCurrentActiveItem,
    activeItemIndex = _ref.activeItemIndex,
    _ref$isSwipeableBefor = _ref.isSwipeableBeforeChange,
    isSwipeableBeforeChange = _ref$isSwipeableBefor === void 0 ? false : _ref$isSwipeableBefor,
    handleCustomAfterChange = _ref.handleCustomAfterChange;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var nextArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'nextArrowLabel') || 'Next slide';
  var prevArrowLabel = getGlobalDictionaryTerm(sitecoreContext, 'prevArrowLabel') || 'Previous slide';
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    swipeable = _useState2[0],
    setSwipeable = _useState2[1];
  var _useState3 = useState(function () {
      return canUseDOM ? window.matchMedia("(max-width: 768px)").matches : false;
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobile = _useState4[0],
    setIsMobile = _useState4[1];
  var carouselRef = React.useRef(null);
  var totalCarouselItems = React.useRef(0);
  var deviceType = '';
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary') || 'var(--main-color)';
  var accessabilitySlidesUpdate = function accessabilitySlidesUpdate() {
    var slides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var focusableSelectors = '.exclude-slider-hidden';
    if (slides.length) {
      for (var index = 0; index < slides.length; index++) {
        var interactiveElements = slides[index].querySelectorAll(focusableSelectors);
        var slide = slides[index];
        for (var interIndex = 0; interIndex < interactiveElements.length; interIndex++) {
          var focusableElement = interactiveElements[interIndex];
          if (slide.ariaHidden === 'true') {
            focusableElement.removeAttribute('tabIndex');
          } else {
            focusableElement.setAttribute('tabIndex', '0');
          }
        }
      }
    }
  };
  React.useEffect(function () {
    var container = get(carouselRef, 'current.containerRef.current');
    var slidesList = get(carouselRef, 'current.listRef.current.children');
    if (container) {
      container.addEventListener('touchstart', touchStart);
      container.addEventListener('touchmove', preventTouch, {
        passive: false
      });
    }
    setTimeout(function () {
      accessabilitySlidesUpdate(slidesList);
    }, 10);
    return function () {
      // if (carouselRef.current.containerRef.current) {
      //   carouselRef.current.containerRef.current.removeEventListener("touchstart", touchStart);
      //   carouselRef.current.containerRef.current.removeEventListener("touchmove", preventTouch, {
      //     passive: false
      //   });
      // }
    };
  }, [carouselRef]);
  React.useEffect(function () {
    if (typeof activeItemIndex !== 'undefined' && activeItemIndex != -1) {
      moveToSlide(activeItemIndex); // TODO why this code don`t work second time????
    }
  }, [activeItemIndex]);
  var _React$useState = React.useState({
      domLoaded: false,
      currentSlide: 0,
      totalItems: 0,
      slidesToShow: 0,
      dotsTotal: 0,
      carouselRef: carouselRef,
      deviceType: deviceType
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  useEffect(function () {
    if (canUseDOM) {
      window.addEventListener('resize', function () {
        setIsMobile(window.matchMedia("(max-width: 768px)").matches);
      });
    }
    return function () {
      if (canUseDOM) {
        window.addEventListener('resize', function () {
          setIsMobile(window.matchMedia("(max-width: 768px)").matches);
        });
      }
    };
  }, []);
  var handleBeforeChange = React.useCallback(function (nextSlide, data, swipeAnalytics) {
    //const carousalContainerRef = get(carouselRef, 'current.containerRef.current');
    var isNext = nextSlide > data.currentSlide;
    var currentSlide = state.currentSlide,
      totalItems = state.totalItems,
      deviceType = state.deviceType;
    var nextIndex = isNext ? currentSlide + 1 < totalItems && currentSlide + 1 || 0 : currentSlide ? currentSlide - 1 : totalItems - 1;
    setState(_objectSpread(_objectSpread({}, state), {}, {
      currentSlide: nextIndex
    }));
    stopVideos();
    if (getCurrentActiveItem) {
      getCurrentActiveItem(nextSlide);
    }
    if ((deviceType == 'mobile' || deviceType == 'tablet') && swipeAnalytics) {
      swipeAnalytics(isNext);
    }
  }, [state]);
  var handleAfterChange = React.useCallback(function (_ref2) {
    var currentSlide = _ref2.currentSlide;
    var slidesList = get(carouselRef, 'current.listRef.current.children');
    if (moduleRef && moduleRef.current) {
      moduleRef.current.focus();
    }
    accessabilitySlidesUpdate(slidesList);
  }, [state]);
  var handleCarouselNext = function handleCarouselNext() {
    carouselRef.current.next();
  };
  var stopVideos = function stopVideos() {
    var carousalContainerRef = get(carouselRef, 'current.containerRef.current');
    if (carousalContainerRef) {
      /*
        finding all the iframe and resting the source so the video will be stopped after slide changed
        */

      var htmlItems = carousalContainerRef.querySelectorAll('.react-multi-carousel-item');
      for (var index = 0; index < htmlItems.length; index++) {
        var item = htmlItems[index];
        if (item.classList.contains('react-multi-carousel-item--active')) {
          var iframe = item.querySelector('iframe');
          var video = item.querySelector('video');
          if (iframe !== null) {
            var currentSrc = iframe.getAttribute('src');
            currentSrc = currentSrc.replace('autoplay=1&', '');
            iframe.setAttribute('src', currentSrc);
          }
          if (video !== null) {
            video.pause();
          }
        }
      }
    }
  };
  var HandleCarouselDomLoaded = function HandleCarouselDomLoaded(_ref3) {
    var carouselState = _ref3.carouselState;
    React.useEffect(function () {
      var domLoaded = carouselState.domLoaded,
        currentSlide = carouselState.currentSlide,
        slidesToShow = carouselState.slidesToShow,
        totalItems = carouselState.totalItems,
        deviceType = carouselState.deviceType;
      totalCarouselItems.current = totalItems;
      if (domLoaded) {
        var dotsTotal = Math.ceil(totalItems - slidesToShow + 1);
        setState({
          domLoaded: domLoaded,
          currentSlide: currentSlide,
          slidesToShow: slidesToShow,
          totalItems: totalItems,
          dotsTotal: dotsTotal,
          carouselRef: carouselRef,
          deviceType: deviceType
        });
      }
    }, [carouselState]);
    return null;
  };
  var HandleItemsChange = function HandleItemsChange(_ref4) {
    var carouselState = _ref4.carouselState;
    React.useEffect(function () {
      var currentSlide = carouselState.currentSlide,
        slidesToShow = carouselState.slidesToShow,
        totalItems = carouselState.totalItems,
        deviceType = carouselState.deviceType;
      if (totalItems !== state.totalItems || currentSlide !== state.currentSlide || deviceType != state.deviceType) {
        var dotsTotal = Math.ceil(totalItems - slidesToShow + 1);
        if (currentSlide > 0 && dotsTotal === 1) {
          carouselRef.current.goToSlide(0);
        }
        setState(_objectSpread(_objectSpread({}, state), {}, {
          totalItems: totalItems,
          currentSlide: currentSlide,
          dotsTotal: dotsTotal,
          deviceType: deviceType
        }));
      }
    }, [carouselState]);
    return null;
  };
  var firstClientX, clientX;
  var preventTouch = function preventTouch(e) {
    var minValue = 5; // threshold
    clientX = e.touches[0].clientX - firstClientX;

    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(clientX) > minValue) {
      e.preventDefault();
      e.returnValue = false;
      return false;
    }
  };
  var touchStart = function touchStart(e) {
    firstClientX = e.touches[0].clientX;
  };
  var renderCarousel = function renderCarousel(items, config, swipeAnalytics) {
    return /*#__PURE__*/React.createElement(Carousel, _extends({
      slidesToSlide: activeItemIndex || 1 // TODO rewrite logic activeItemIndex is can`t be slidesToSlide
      ,

      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : ''),
      ssr: true // means to render carousel on server-side.
      ,

      deviceType: isMobile ? 'mobile' : 'desktop' // Only pass this when use for server-side rendering
      ,

      arrows: false,
      minimumTouchDrag: isMobile ? 5 : 100,
      additionalTransfrom: 1,
      ref: carouselRef,
      transitionDuration: isMobile ? 1 : 100,
      swipeable: isMobile ? swipeable : true,
      beforeChange: function beforeChange(nextSlide, data) {
        setSwipeable(isSwipeableBeforeChange);
        handleBeforeChange(nextSlide, data, swipeAnalytics);
      },
      afterChange: function afterChange(e, data) {
        setSwipeable(true);
        handleAfterChange(data);
        if (handleCustomAfterChange) {
          handleCustomAfterChange(data);
        }
      },
      customButtonGroup: !state.domLoaded ? /*#__PURE__*/React.createElement(HandleCarouselDomLoaded, null) : /*#__PURE__*/React.createElement(HandleItemsChange, null),
      rtl: rtl
    }, config), items);
  };
  var renderDayOverview = function renderDayOverview(items) {
    if (!state.dotsTotal || state.dotsTotal <= 1) return null;
    var middleArrIndex = Math.ceil(items.length / 2);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "offset-xl-1 col-lg-2 col-xl-2"
    }, items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, index < middleArrIndex && /*#__PURE__*/React.createElement("div", {
        className: "ito__list-item ".concat(state.currentSlide === index ? "ito__list-item--active" : ''),
        key: index,
        onClick: function onClick() {
          carouselRef.current.goToSlide(index);
          EventClickTile();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-small ito__list-link"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ito__item-title js-item",
        "data-item": "js-item-" + Number(index + 1)
      }, items[index]))));
    })), /*#__PURE__*/React.createElement("div", {
      className: "offset-xl-1 col-lg-2 col-xl-2"
    }, items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, index >= middleArrIndex && /*#__PURE__*/React.createElement("div", {
        className: "rigthlist ito__list-item ".concat(state.currentSlide === index ? "ito__list-item--active" : ''),
        onClick: function onClick() {
          if (window.screen.width < 480) carouselRef.current.goToSlide(index);
          if (state.dotsTotal < index) carouselRef.current.goToSlide(index - state.dotsTotal);
          EventClickTile();
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-small ito__list-link"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ito__item-title js-item",
        "data-item": "js-item-" + Number(index + 1)
      }, items[index]))));
    }))));
  };
  var EventClickTile = function EventClickTile() {
    var listItem = document.querySelectorAll('.js-item');
    listItem.forEach(function (item) {
      item.addEventListener('click', function () {
        var dataItem = item.getAttribute('data-item');
        var poiActive = document.querySelectorAll('.ito__item-title');
        var poiInnerActive = document.querySelectorAll('.ito__item-info-inner');
        poiActive.forEach(function (poi) {
          poi.classList.remove('poi--active');
        });
        poiInnerActive.forEach(function (poi) {
          poi.classList.remove('item-inner--active');
        });
        if (dataItem) {
          var dataItemNumber = dataItem.split('js-item-');
          var poiItem = document.querySelector('.js-item-poi-' + dataItemNumber[1]);
          if (poiItem) {
            poiItem.classList.add('poi--active');
            poiItem.parentElement && poiItem.parentElement.classList.add('item-inner--active');
          }
        }
      });
    });
  };
  var moveToSlide = function moveToSlide(slideNo) {
    carouselRef.current.goToSlide(slideNo);
  };
  var renderDots = function renderDots(clickFunc) {
    var pages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!state.dotsTotal || state.dotsTotal <= 1) return null;
    var showThumbs = !!pages.length;
    var itemProgressSpeed = carouselRef.current.props.autoPlaySpeed;
    var range = totalCarouselItems.current === state.dotsTotal ? 0 : 2;
    var carousalInfinite = state.carouselRef.current.props.infinite;
    return carousalInfinite ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : '', " dot-container ").concat(showThumbs ? 'dot-container--thumbed' : ''),
      "data-cy": "carousel-dots",
      style: {
        "--autoplay-interval": "".concat(itemProgressSpeed / 1000, "s")
      }
    }, Array.from(Array(totalCarouselItems.current).keys()).map(function (index) {
      var bulletBackColor = state.currentSlide === index + range ? primaryPageThemeColor : '#c5c5c5';
      var customBulletStyles = showThumbs ? {} : {
        background: bulletBackColor
      };
      return /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        key: index + range,
        className: "dot ".concat(state.currentSlide === index + range ? 'dot--active' : ''),
        onClick: function onClick() {
          carouselRef.current.goToSlide(index + range);
          if (clickFunc) {
            clickFunc();
          }
        },
        onKeyPress: function onKeyPress(event) {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            carouselRef.current.goToSlide(index + range);
            if (clickFunc) {
              clickFunc();
            }
          }
        },
        style: customBulletStyles
      }, showThumbs ? /*#__PURE__*/React.createElement("div", {
        className: "thumb-wrapper"
      }, pages[index].thumbUrl === '?&cw=143&ch=80' ? null : /*#__PURE__*/React.createElement("img", {
        src: pages[index].thumbUrl,
        alt: pages[index].thumbAlt,
        className: "image"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, pages[index].title)) : null);
    })) : /*#__PURE__*/React.createElement("div", {
      className: "dot-container ".concat(showThumbs ? 'dot-container--thumbed' : ''),
      "data-cy": "carousel-dots",
      style: {
        "--autoplay-interval": "".concat(itemProgressSpeed / 1000, "s")
      }
    }, Array.from(Array(state.dotsTotal).keys()).map(function (index) {
      var bulletBackColor = state.currentSlide === index ? primaryPageThemeColor : '#c5c5c5';
      var customBulletStyles = showThumbs ? {} : {
        background: bulletBackColor
      };
      return /*#__PURE__*/React.createElement("div", _extends({
        tabIndex: 0,
        key: index,
        className: "dot ".concat(state.currentSlide === index ? 'dot--active' : ''),
        onClick: function onClick() {
          carouselRef.current.goToSlide(index);
          if (clickFunc) {
            clickFunc();
          }
        },
        onKeyPress: function onKeyPress(event) {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            carouselRef.current.goToSlide(index);
            if (clickFunc) {
              clickFunc();
            }
          }
        }
      }, customBulletStyles), showThumbs ? /*#__PURE__*/React.createElement("div", {
        className: "thumb-wrapper"
      }, pages[index].thumbUrl === '?&cw=143&ch=80' ? null : /*#__PURE__*/React.createElement("img", {
        src: pages[index].thumbUrl,
        alt: pages[index].thumbAlt,
        className: "image"
      }), /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, pages[index].title)) : null);
    }));
  };
  var renderProgressBar = function renderProgressBar(clickFunc) {
    if (!state.dotsTotal || state.dotsTotal <= 1 || totalCarouselItems.current <= 1) return null;
    var carousalInfinite = state.carouselRef.current.props.infinite;
    return carousalInfinite ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : '', " bar-container")
    }, Array.from(Array(totalCarouselItems.current).keys()).map(function (index) {
      return /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        key: index,
        className: "bar ".concat(state.currentSlide === index ? 'bar--active' : ''),
        style: {
          width: "".concat(100 / state.dotsTotal, "%")
        },
        onClick: function onClick() {
          carouselRef.current.goToSlide(index);
          if (clickFunc) {
            clickFunc();
          }
        },
        onKeyPress: function onKeyPress(event) {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            carouselRef.current.goToSlide(index);
            if (clickFunc) {
              clickFunc();
            }
          }
        }
      });
    })) : /*#__PURE__*/React.createElement("div", {
      className: "bar-container"
    }, Array.from(Array(state.dotsTotal).keys()).map(function (index) {
      return /*#__PURE__*/React.createElement("div", {
        tabIndex: 0,
        key: index,
        className: "bar ".concat(state.currentSlide === index ? 'bar--active' : ''),
        style: {
          width: "".concat(100 / state.dotsTotal, "%")
        },
        onClick: function onClick() {
          carouselRef.current.goToSlide(index);
          if (clickFunc) {
            clickFunc();
          }
        },
        onKeyPress: function onKeyPress(event) {
          if (event.key === 'Enter' || event.key === 'NumpadEnter') {
            carouselRef.current.goToSlide(index);
            if (clickFunc) {
              clickFunc();
            }
          }
        }
      });
    }));
  };

  // TODO enableDisableMode should be always true
  var renderPreviousButton = function renderPreviousButton(clickFunc) {
    var enableDisableMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isInteractiveBanner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var customIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!state.domLoaded || !state.dotsTotal || state.dotsTotal <= 1) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isInteractiveBanner ? /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? !state.currentSlide : false,
      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : '', " ").concat(CarouselCssArrow, " carousel-interactive-btn carousel-interactive-btn--left ").concat(state.currentSlide ? '' : 'carousel-icon--inactive'),
      onClick: function onClick() {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.previous();
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.previous();
        }
      },
      tabIndex: !state.currentSlide ? -1 : 0,
      "data-cy": "carousel-prev-button",
      style: {
        opacity: !state.currentSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: !state.currentSlide ? 'not-allowed' : 'pointer'
      },
      "aria-label": prevArrowLabel,
      title: prevArrowLabel
    }, /*#__PURE__*/React.createElement("div", {
      className: "testBlock"
    }), /*#__PURE__*/React.createElement("svg", {
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M7.70517 1.41002L6.29517 1.52588e-05L0.295166 6.00002L6.29517 12L7.70517 10.59L3.12517 6.00002L7.70517 1.41002Z",
      fill: "#fff"
    }))) : /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? !state.currentSlide : false,
      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : '', " ").concat(CarouselCssArrow, " my-icon-white carousel-icon carousel-icon-left ").concat(state.currentSlide ? '' : 'carousel-icon--inactive'),
      onClick: function onClick() {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.previous();
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.previous();
        }
      },
      tabIndex: !state.currentSlide ? -1 : 0,
      "data-cy": "carousel-prev-button",
      style: {
        opacity: !state.currentSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: !state.currentSlide ? 'not-allowed' : 'pointer'
      },
      "aria-label": prevArrowLabel,
      title: prevArrowLabel
    }, customIcon ? customIcon : /*#__PURE__*/React.createElement(LeftCarouselArrow, {
      className: "icon",
      style: {
        color: "".concat(primaryPageThemeColor)
      }
    })));
  };

  // TODO enableDisableMode should be always true
  var renderNextButton = function renderNextButton(clickFunc) {
    var enableDisableMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isInteractiveBanner = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var customIcon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    if (!state.domLoaded || !state.dotsTotal || state.dotsTotal <= 1) return null;
    var isLastSlide = state.currentSlide + 1 === state.dotsTotal;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isInteractiveBanner ? /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? isLastSlide : false,
      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : '', " ").concat(CarouselCssArrow, " carousel-interactive-btn carousel-interactive-btn--right ").concat(isLastSlide ? 'carousel-icon--inactive' : ''),
      onClick: function onClick() {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.next();
        if (typeof window !== 'undefined') {
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.next();
        }
      },
      "data-cy": "carousel-next-button",
      tabIndex: isLastSlide ? -1 : 0,
      style: {
        opacity: isLastSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: isLastSlide ? 'not-allowed' : 'pointer',
        userSelect: 'none'
      },
      "aria-label": nextArrowLabel,
      title: nextArrowLabel
    }, /*#__PURE__*/React.createElement("svg", {
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M1.70517 1.52588e-05L0.295166 1.41002L4.87517 6.00002L0.295166 10.59L1.70517 12L7.70517 6.00002L1.70517 1.52588e-05Z",
      fill: "white"
    }))) : /*#__PURE__*/React.createElement("button", {
      disabled: enableDisableMode ? isLastSlide : false,
      className: "".concat(Main, " ").concat(rtl ? rtlCarousel : '', " ").concat(CarouselCssArrow, " my-icon-white carousel-icon carousel-icon-right ").concat(isLastSlide ? 'carousel-icon--inactive' : ''),
      onClick: function onClick() {
        if (clickFunc) {
          clickFunc();
        }
        carouselRef.current.next();
        if (typeof window !== 'undefined') {
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }
      },
      onKeyPress: function onKeyPress(event) {
        if (event.key === 'Enter' || event.key === 'NumpadEnter') {
          if (clickFunc) {
            clickFunc();
          }
          carouselRef.current.next();
        }
      },
      "data-cy": "carousel-next-button",
      tabIndex: isLastSlide ? -1 : 0,
      style: {
        opacity: isLastSlide ? 0.4 : 1,
        transition: 'opacity 0.3s',
        cursor: isLastSlide ? 'not-allowed' : 'pointer',
        userSelect: 'none'
      },
      "aria-label": nextArrowLabel,
      title: nextArrowLabel
    }, customIcon ? customIcon : /*#__PURE__*/React.createElement(RightCarouselArrow, {
      className: "icon",
      style: {
        color: "".concat(primaryPageThemeColor)
      }
    })));
  };
  return children({
    renderCarousel: renderCarousel,
    state: state,
    renderDots: renderDots,
    renderProgressBar: renderProgressBar,
    renderPreviousButton: renderPreviousButton,
    renderNextButton: renderNextButton,
    renderDayOverview: renderDayOverview,
    moveToSlide: moveToSlide
  });
};
var CarouselCssArrow = "c17l4y6v";
var Main = "m52ytox";
var rtlCarousel = "r1pt7db2";
export default CarouselProvider;